const env = process.env.RAZZLE_GOTOMBOLA_ENV || 'prod';

export function buildMicroserviceEndpoint(name: string): string {
    return `https://${name}.${env === 'prod' ? '' : `${env}.`}gotombola.co`;
}

export default buildMicroserviceEndpoint;
